import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopyToFolder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 4.5H9L7.5 3H3C2.1675 3 1.5075 3.6675 1.5075 4.5L1.5 13.5C1.5 14.3325 2.1675 15 3 15H15C15.8325 15 16.5 14.3325 16.5 13.5V6C16.5 5.1675 15.8325 4.5 15 4.5ZM15 13.5H3V4.5H6.8775L8.3775 6H15V13.5ZM9 10.5H10.5V12H12V10.5H13.5V9H12V7.5H10.5V9H9V10.5Z",
		fill: "#1D1D1D"
	})
});
export default SvgCopyToFolder;
